/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Rates_Continuity_ErrorInputs */

const fr_client_rates_continuity_error = /** @type {(inputs: Client_Rates_Continuity_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ces périodes ne se suivent pas.`)
};

const en_client_rates_continuity_error = /** @type {(inputs: Client_Rates_Continuity_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These periods are not continuous.`)
};

/**
* | output |
* | --- |
* | "These periods are not continuous." |
*
* @param {Client_Rates_Continuity_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const client_rates_continuity_error = /** @type {((inputs?: Client_Rates_Continuity_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Rates_Continuity_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_rates_continuity_error(inputs)
	return fr_client_rates_continuity_error(inputs)
});